var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"isotope-app",class:_vm.$route.name,attrs:{"id":"app"}},[_c('router-view',{staticClass:"isotope-page"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }